var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewsMenuActiveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "chat_724741",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28933",
    "data-name": "Group 28933"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39819",
    "data-name": "Path 39819",
    d: "M24.5,0H3.5A3.5,3.5,0,0,0,0,3.5V19.25a3.5,3.5,0,0,0,3.5,3.5H5.25v4.375a.876.876,0,0,0,.5.793A.888.888,0,0,0,6.125,28a.865.865,0,0,0,.56-.2l6.057-5.047H24.5a3.5,3.5,0,0,0,3.5-3.5V3.5A3.5,3.5,0,0,0,24.5,0Zm-14,13.125A.875.875,0,0,1,9.625,14H4.375a.875.875,0,0,1-.875-.875v-7a.875.875,0,0,1,.875-.875h5.25a.875.875,0,0,1,.875.875ZM18.375,17.5h-5.25a.875.875,0,0,1,0-1.75h5.25a.875.875,0,0,1,0,1.75Zm5.25-5.25h-10.5a.875.875,0,0,1,0-1.75h10.5a.875.875,0,0,1,0,1.75Zm0-5.25h-10.5a.875.875,0,0,1,0-1.75h10.5a.875.875,0,0,1,0,1.75Z",
    fill: "#ed1c24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsMenuActiveIcon);
export default __webpack_public_path__ + "static/media/news_menu_Active_icon.2fe0ee1fe69b21bba38d30ac62ed67ca.svg";
export { ForwardRef as ReactComponent };